export const mapsArray: Array<string> = [`
WWWWWWWWWWWWWWWWWWWWWWWWWWWW
WWWWWWWWWWWWWWWWWWWWWWWWWWWW
W............WW............W
W.WWWW.iWWWi.WW.iWWWi.WWWW.W
W.WWWW.WWWWW.WW.WWWWW.WWWW.W
W.WWWW.WWWWW.ii.WWWWW.WWWW.W
W..........................W
W.WWWW.WW.WWWWWWWW.WW.WWWW.W
W.WWWW.WW.WWWWWWWW.WW.WWWW.W
W......WW....WW....WW......W
W.iWWi.WWWWi.WW.iWWWW.iWWi.W
W.WWWW.WWWWW.WW.WWWWW.WWWW.W
W.WWWW.WW..........WW.WWWW.W
W.WWWW.WW.iWWWWWWi.WW.WWWW.W
W.iWWi.WW.WeeeeeeW.WW.iWWi.W
W.........WeeSeeeW.........W
W.WWWW.WW.WeeeeeeW.WW.WWWW.W
W.WWWW.WW.WWieeiWW.WW.WWWW.W
W.WWWW.WW..........WW.WWWW.W
W.WWWW.WW.WWWWWWWW.WW.WWWW.W
W.WWWW.WW.WWWWWWWW.WW.WWWW.W
W............WW............W
W.iWWi.WWWWW.WW.WWWWW.iWWi.W
W.WWWW.WWWWW.WW.WWWWW.WWWW.W
W...WW................WW...W
WWW.WW.WW.iWWWWWWi.WW.WW.WWW
WWW.WW.WW.WWWWWWWW.WW.WW.WWW
W......WW....WW....WW......W
W.iWWWWWWWWW.WW.WWWWWWWWWi.W
W.WWWWWWWWWW.WW.WWWWWWWWWW.W
W..........................W
WWWWWWWWWWWWWWWWWWWWWWWWWWWW
`, `
WWWWWWWWWWWWWWWWWWWWWWWWWWWW
WWWWWWWWWWWWWWWWWWWWWWWWWWWW
W......WW....WW....WW......W
W.iWWi.WW.Wi.WW.iW.WW.iWWi.W
W.WWWW.WW.WW.WW.WW.WW.WWWW.W
W.iWWi.WW.WW.ii.WW.WW.iWWi.W
W......WW..........WW......W
WWWWWW.WW.iWWWWWWi.WW.WWWWWW
WWWWWW.WW.WWWWWWWW.WW.WWWWWW
W......WW....WW....WW......W
WWWWWi.WWWWi.WW.iWWWW.iWWWWW
WWWWWi.WWWWW.WW.WWWWW.iWWWWW
W......WW..........WW......W
W.iWWi.WW.iWWeeWWi.WW.iWWi.W
W.WWWW.WW.WeeeeeeW.WW.WWWW.W
W.WWWW....eeeSeeee....WWWW.W
W.WWWWWWi.WeeeeeeW.iWWWWWW.W
W.iWWWWWW.WWieeiWW.WWWWWWi.W
W......WW..........WW......W
W.WWWW.WW.WWWWWWWW.WW.WWWWWW
W.WWWW.WW.WWWWWWWW.WW.WWWWWW
W............WW............W
W.iWWi.WWWWW.WW.WWWWW.iWWi.W
W.WWWW.WWWWW.WW.WWWWW.WWWW.W
W...WW.......WW.......WW...W
WWi.WWWWi.iWWWWWWi.iWWWW.iWW
WWi.WWWWi.iWWWWWWi.iWWWW.iWW
W............WW............W
W.iWWWWWWWWi.WW.iWWWWWWWWi.W
W.iWWWWWWWWi.WW.iWWWWWWWWi.W
W............WW............W
WWWWWWWWWWWWWWWWWWWWWWWWWWWW
`,
  `
WWWWWWWWWWWWWWWWWWWWWWWWWWWW
WWWWWWWWWWWWWWWWWWWWWWWWWWWW
i......ii....ii....ii......i
i.iiii.ii.ii.ii.ii.ii.iiii.i
i.iiii.ii.ii.ii.ii.ii.iiii.i
i.iiii.ii.ii.ii.ii.ii.iiii.i
i......ii..........ii......i
i.iiiiiii.iiiiiiii.iiiiiii.i
i.iiiiiii.iiiiiiii.iiiiiii.i
i......ii....ii....ii......i
iiiiii.iiiii.ii.iiiii.iiiiii
iiiiii.iiiii.ii.iiiii.iiiiii
i......ii....ii....ii......i
i.iiii.ii.iiiiiiii.ii.iiii.i
i.iiii.ii.ieeeeeei.ii.iiii.i
i......ii.eeeSeeee.ii......i
i.iiiiiii.ieeeeeei.iiiiiii.i
i.iiiiiii.iiiiiiii.iiiiiii.i
i......ii....ii....ii......i
i.iiii.ii.iiiiiiii.ii.iiiiii
i.iiii.ii.iiiiiiii.ii.iiiiii
i............ii............i
i.iiii.iiiii.ii.iiiii.iiii.i
i.iiii.iiiii.ii.iiiii.iiii.i
i...ii.......ii.......ii...i
iii.iiiii.iiiiiiii.iiiii.iii
iii.iiiii.iiiiiiii.iiiii.iii
i............ii............i
i.iiiiiiiiii.ii.iiiiiiiiii.i
i.iiiiiiiiii.ii.iiiiiiiiii.i
i............ii............i
iiiiiiiiiiiiiiiiiiiiiiiiiiii
`,]